import { useMutation } from "@tanstack/react-query";
import { getBackendUrl } from "api/common";
import { queryFnPOST } from "api/tanStackQuery/helpers";
import { ProductionDeviationModal } from "features/CenterContent/RoleContent/ProductionDeviation/ProductionDeviationModal";
import { ProductionDeviationRequest } from "features/CenterContent/RoleContent/ProductionDeviation/types/requestSchema";
import { FC } from "react";

type CreateProductionDeviationModalProps = {
  onClose: () => void;
};

export const CreateProductionDeviationModal: FC<
  CreateProductionDeviationModalProps
> = ({ onClose }) => {
  const { mutate: post, status } = useMutation({
    mutationFn: (body: ProductionDeviationRequest) =>
      queryFnPOST<unknown>({
        url: `${getBackendUrl()}/production-deviation`,
        body,
        signal: undefined,
      }),
  });
  return (
    <ProductionDeviationModal post={post} status={status} onClose={onClose} />
  );
};
